import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import api from '@/plugins/axios'
interface User {
  id: number
  name: string
  email: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'UsersView'
},
  __name: 'UsersView',
  setup(__props) {


const users = ref<User[]>([])

const headers = [
  { title: 'ID', value: 'id' },
  { title: 'Nombre', value: 'username' },
  { title: 'date', value: 'creado' }
]

const fetchUsers = async () => {
  const res = await api.get('/usuario')
  users.value = res.data
}

onMounted(fetchUsers)

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "pa-4" }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Usuarios", -1)),
      _createVNode(_component_v_btn, {
        color: "primary",
        onClick: fetchUsers
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Recargar")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_v_data_table, {
        items: users.value,
        headers: headers,
        class: "mt-4"
      }, null, 8, ["items"])
    ]),
    _: 1,
    __: [1]
  }))
}
}

})